var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p-pagination',{attrs:{"firstLastButtons":true,"language":_vm.language,"itemName":_vm.itemName},on:{"change":_vm.change,"input":_vm.change},model:{value:(_vm.pagination),callback:function ($$v) {_vm.pagination=$$v},expression:"pagination"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }